export function countBetween(values, min, max) {
  return values.filter(v => v >= min && v < max).length;
}